import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Icon from '../../common/Icons';
import './ManagementCard.css';

/**
 * ManagementCard - Carte de gestion avec actions multiples
 * 
 * @param {string} title - Titre de la section
 * @param {string} icon - Icône principale
 * @param {string} color - Couleur thématique
 * @param {array} actions - Liste des actions [{title, description, icon, color, onClick}]
 */
const ManagementCard = ({ 
  title, 
  icon, 
  color = 'primary', 
  actions = [] 
}) => {
  return (
    <Card className="management-card border-0 shadow-sm h-100">
      <Card.Header className={`management-header bg-${color} bg-opacity-10 border-0`}>
        <h5 className={`mb-0 text-${color} d-flex align-items-center`}>
          <Icon name={icon} size={22} className="me-2" />
          {title}
        </h5>
      </Card.Header>
      
      <Card.Body className="p-3">
        <Row className="g-3">
          {actions.map((action, index) => (
            <Col key={index} xs={12} sm={6}>
              <div 
                className={`management-action-item ${action.disabled ? 'disabled' : ''}`}
                onClick={action.disabled ? undefined : action.onClick}
              >
                <div className={`action-item-icon bg-${action.color} bg-opacity-10 text-${action.color}`}>
                  <Icon name={action.icon} size={24} />
                </div>
                
                <div className="action-item-content">
                  <h6 className="action-item-title mb-1">{action.title}</h6>
                  <small className="action-item-description text-muted">
                    {action.description}
                  </small>
                </div>
                
                {action.badge && (
                  <span className={`action-item-badge badge bg-${action.badgeColor || 'danger'}`}>
                    {action.badge}
                  </span>
                )}
                
                <div className="action-item-arrow">
                  <Icon name="chevronRight" size={16} />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ManagementCard;
